export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "hi": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["kuboard"])}
      },
      "zh": {
        "hi": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["kuboard"])}
      }
    }
  })
}
